import React from 'react'
import { Button } from '../../components/Button/Button'
import classes from './css/SectionOne.module.css'
import useMediaQuery from '@material-ui/core/useMediaQuery'
import { slideInDown, slideInUp } from 'react-animations';
import styled, { keyframes } from 'styled-components'
const bounceAnimation = keyframes`${slideInDown}`;
const slideUpAnimation = keyframes`${slideInUp}`
const Bounce = styled.div`
  animation: 1.2s ${bounceAnimation};
`;
const SlideUp = styled.div`
 animation: 1s ${slideUpAnimation};
`
export const SectionOne: React.FC = () => {
   
    const matches = useMediaQuery('(max-width:1094px)')
 
    return (
    <section>
       <div className={classes.bg} />
       <div className={classes.darker}>
        <div className={classes.infoContainer}>
            <div className={classes.infoDiv}>
            <Bounce>
                <p className={classes.title}>وظائف مدينة السادات</p>
                <p className={classes.text}>فرص العمل المتوفرة في جميع انحاء مدينة السادات</p>
            </Bounce>
            <SlideUp className={classes.btns}>
             <Button 
                width={matches ? 190 : 180} 
                height={matches ? 46 : 46 }
                bordercolor={matches ? 'rgba(255,255,255,0.7)' : '#494D60'}
                to='/register'
                style={{marginBottom: matches ? 13 : 0}}
                >التسجيل</Button>
             <Button 
                bordercolor={matches ? 'rgba(255,255,255,0.7)' : '#494D60'}
                width={matches ? 190 : 180} 
                height={matches ? 46 : 46 } 
                color={'rgba(255,255,255,0.05)'}
                to='/jobs'
                >الوظائف المتاحة</Button>
             </SlideUp>
            </div>
        </div>
       </div>
    </section>
    )
}
